import type { FC } from 'react';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import logo from '../res/img/logo_horizontal_white.png';

interface LogoProps {
  sx?: SxProps<Theme>;
}
const LogoWhite: FC<LogoProps> = (props) => (
  <div>
    <img src={logo} width={"100%"} height="50"/>
  </div>
);

export default LogoWhite;
